import React, {useEffect, useState} from "react";

import TitleHeader from "../product/TitleHeader";
import {IsLP_MP_SP} from "my-styles/media/media";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Navigation} from "swiper";
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import ArticleBox from "./ArticleBox";


SwiperCore.use([Navigation])

export default function ArticleList(props) {

    const header = props.data && props.data.header ? props.data.header : null;
    const lines = props.data && props.data.lines ? props.data.lines : null;

    const [pageWidth, setPageWidth] = useState(0)
    const boxRef = React.createRef()

    useEffect(() => {
        if (boxRef.current) {
            setPageWidth(boxRef.current.getBoundingClientRect().width)
        }
    }, [boxRef])


    let maxWidth = Math.max.apply(Math, lines.map((item) => {
        return item.width
    }))
    let maxWidthPercent = (pageWidth * (maxWidth / 100))
    let listWidth = 0;
    let list

    for (let listItem of lines) {
        listWidth += parseInt(listItem.width)
    }
    let slidesPerView = 100 / maxWidth;

    if (listWidth > 100 && IsLP_MP_SP()) {
        list = <div ref={boxRef}>
            <Swiper
                dir="rtl"
                slidesPerView={slidesPerView}
                spaceBetween={30}
                navigation={true}
                modules={[Navigation]}>
                {lines.map((listItem, slideIndex) => {
                    if (pageWidth !== 0) {
                        let heightUnit = maxWidthPercent * (header.max_height / 100) + "px"
                        return <SwiperSlide key={slideIndex} className="center">
                            <ArticleBox {...props} article={listItem} lines={lines} heightUnit={heightUnit}
                                        width={maxWidthPercent + "px"}/>
                        </SwiperSlide>
                    } else {
                        return null
                    }
                })}
            </Swiper>
        </div>
    } else {
        list = <div ref={boxRef}
                    className={"marginTopBottomSmall hideHScrollInWebShowHScrollInMobile"}
                    style={{whiteSpace: listWidth<=100? '' :"nowrap",display: listWidth<=100? 'flex' :"block" ,textAlign:'justify'}}>
            {lines.map((listItem, i) => {
                let heightUnit = maxWidthPercent * (header.max_height / 100) + "px";
                return <ArticleBox key={i} {...props} article={listItem} heightUnit={heightUnit}
                                   width={maxWidthPercent + "px"}/>
            })}
        </div>
    }

    return (
        <div style={{marginTop: "1em"}}>
            {header.title &&
            <TitleHeader
                onAllClicked={props.onAllClicked} header={header}/>
            }
            {list}
        </div>
    )

}